import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button, Col, Form, Input, message } from "antd";
import { LoginFormData } from "./type/login.type";
import { Checkbox } from "antd/lib";

interface ILoginViewProps {
    onSubmit: (data: LoginFormData) => Promise<void>;
    handleRememberMeLogic: (val: boolean) => void;
}

const LoginView = (props: ILoginViewProps) => {
    const [form] = Form.useForm();

    async function handleFormSubmit() {
        await form.validateFields()
            .then((formValues: LoginFormData) => {
                console.log(formValues, '1234')
                props.onSubmit(formValues);
            })
            .catch(() => message.error("Please fill all the required fields!"));
    }


    return (
        <Col className="login-credentials">
            <Form
                form={form}
                layout={'vertical'}
            >
                <Col span={18}>
                    <Form.Item
                        name="email"
                        label="Email"
                        rules={[
                            {
                                required: true,
                                message: "Please enter the email",
                            },
                            {
                                pattern: new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/),
                                message: "Please enter a valid email",
                            },
                        ]}
                    >
                        <Input placeholder='Enter the email'/>
                    </Form.Item>
                </Col>

                <Col span={18}>
                    <Form.Item
                        label="Password"
                        name="password"
                        rules={[
                            {
                                required: true,
                                message: "Please enter the password",
                            }
                        ]}
                    >
                        <Input.Password
                            placeholder="Enter the password"
                            visibilityToggle
                        />
                    </Form.Item>
                </Col>

                <Col span={18} className={'pw-rm-wrapper'}>
                    <Form.Item
                        label=""
                        name="rememberMe"
                        valuePropName="checked"
                    >
                        <Checkbox>Remember Me</Checkbox>
                    </Form.Item>


                    <Link
                        to={"/forgot-password"}
                        className="forgot-password"
                    >
                        Forgot Password?
                    </Link>
                </Col>


                <Col span={18}>
                    <div className="login-button">
                        <Button
                            type="primary"
                            htmlType="submit"
                            onClick={handleFormSubmit}
                        >
                            {" "}
                            Login &#8640;
                        </Button>
                    </div>
                </Col>
            </Form>
            <div className="social-icons"/>

        </Col>
    );
}

export default LoginView;
